<template>
    <div id="wrapper">
        <side-bar :memuData="view.memuData" :memuConfig="view.memuConfig" :dashboardConfig="view.dashboardConfig"></side-bar>
        <div class="d-flex flex-column" id="content-wrapper">
            <div class="content" id="content">
                <top-bar></top-bar>
                <router-view></router-view>
            </div>
        </div>
    </div>
</template>

<script>
import SideBar from '@/components/layouts/SideBar'
import TopBar from '@/components/layouts/TopBar'

export default {
    name: 'toHelpingOthersLayout',
    components:{
        SideBar,
        TopBar
    },
    data() {
        return {
            view: {
                memuConfig: {
                    link: '/backstage/toHelpingOthers/dashboard',
                    systemName: '永豐網路平台',
                    version: '1.0'
                },
                dashboardConfig: {
                  title: '儀表板',
                  link: '/backstage/toHelpingOthers/dashboard',
                  display: true
                },
                memuData: [
                    {
                        'title': '資料管理', tag: 'data_management', url: '#', icon: 'fas fa-solid fa-file', isShow:false, meta: { permission: ['search'] }, children: [
                            { name: '要助人資料', tag: 'information', url: '/backstage/toHelpingOthers/information', meta: { permission: ['search'] }},
                        ]
                    },
                    {
                        'title': '契約管理', tag: 'contract_management', url: '#', icon: 'fas fa-solid fa-file-signature', isShow:false, meta: { permission: ['search'] }, children: [
                            { name: '契約', tag: 'contract', url: '/backstage/toHelpingOthers/contract', meta: { permission: ['search'] }},
                        ]
                    },
                    {
                        'title': '繳費管理', tag: 'pay_management', url: '#', icon: 'fas fa-sharp fa-solid fa-credit-card', isShow:false, meta: { permission: ['search'] }, children: [
                            { name: '繳費', tag: 'pay', url: '/backstage/toHelpingOthers/pay', meta: { permission: ['search'] }},
                            { name: '合併帳單', tag: 'mergeBill', url: '/backstage/toHelpingOthers/mergeBill', meta: { permission: ['search'] }},
                        ]
                    }
                ]
            },
        }
    },
    mounted() {
        this.load();
    },
    methods: {
        async load() {
            //側邊欄重整子選單不能關閉
            // let subMenu = JSON.parse(localStorage.getItem('sideBar'));
            // if(subMenu) this.view.memuData = subMenu;
        },
    }
}
</script>

<style lang="scss" scoped>
// Main page wrapper
#wrapper {
  display: flex;
  #content-wrapper {
    background-color: #FFFFFF;
    // width: 100vw;
    flex: 1 1 auto;
    overflow-x: hidden;
    #content {
      flex: 1 0 auto;
      min-height: 100vh;
      @media screen and (max-width: 720px) {
        margin-left: 0vw !important;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Backstage/toHelpingOthers/Layout.vue